<template>
  <div class="footer">
    <div class="footer-top">
      <ul class="footer-links">
        <li v-for="page in cms.list" class="footer-links-item">
          <router-link
            class="footer-links-link"
            :to="{ name: 'showPage', params: { type: page.pagetype }}"
          >{{page.title}}</router-link>
        </li>
        <li class="footer-links-item">
          <router-link class="footer-links-link" :to="{ name: 'contact' }">Kontakt</router-link>
        </li>
      </ul>

      <div>
        <Page class="footer-page-template" type="FOOTER" />
      </div>
    </div>

    <div class="footer-bottom bg-info">
      <p
        class="footer-copy"
      >© 2019 PPHU mini-maxi Irena Wydra - Internetowa Platforma Handlowa Redbay B2B</p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Page } from "../RedbayComponents";

export default {
  components: { Page },
  computed: {
    ...mapState({
      cms: state => state.cms
    })
  },
  beforeMount() {
    this.$store.dispatch("cms/getList");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/template/Footer.vue